export const socialLinks = {
  discord: 'https://discord.gg/x26vwJze',
};
